import { invokeRPC } from './socket.js'

export const getAllSupportDetails = () => {
  return invokeRPC('supportDept', 'getAllSupportDetails')
}

export const getAllSupportEmails = () => {
  return invokeRPC('supportDept', 'getAllSupportEmails')
}

export const getSupportEmailsForCustomer = (id) => {
  return invokeRPC('supportDept', 'getSupportEmailsForCustomer', { customer_id: id })
}

export const addSupportEmailForCustomer = (customer_id, support_id) => {
  return invokeRPC('supportDept', 'addSupportEmailForCustomer', {
    customer_id: customer_id,
    support_id: support_id
  })
}

export const removeSupportEmailForCustomer = (customer_id, support_id) => {
  return invokeRPC('supportDept', 'removeSupportEmailForCustomer', {
    customer_id: customer_id,
    support_id: support_id
  })
}